<template>
  <!--   Main Content Start Here   -->
  <main>
    <div v-if="loader">
      <div class="spinner"></div>
    </div>
    <section class="dashboard_wraper">
      <div class="container_large">
        <div class="row">
          <!-- starting side bar -->
          <sidebar-component></sidebar-component>
          <!-- ending sidebar  -->
          <div class="col-md-12 col-lg-9">
            <div class="dashboard_card">
              <h2>Account Settings</h2>
              <div class="account_form">
                <form method="" action="" @submit.prevent="updateAccount()">
                  <div class="row">
                    <div
                      class="alert alert-success alert-dismissible"
                      v-if="
                        status &&
                        status.account_success &&
                        status.account_success == 200
                      "
                    >
                      <strong>Success!</strong> Action performed successfully.
                    </div>
                    <div class="col-md-6">
                      <div class="form_group">
                        <label>First Name</label>
                        <input
                          type="text"
                          name=""
                          v-model="formObjAccount.first_name"
                          required
                        />
                        <v-errors :errors="errorFor('first_name')"></v-errors>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form_group">
                        <label>Last Name</label>
                        <input
                          type="text"
                          name=""
                          v-model="formObjAccount.last_name"
                          required
                        />
                        <v-errors :errors="errorFor('last_name')"></v-errors>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form_group">
                        <label>Email</label>
                        <input
                          type="email"
                          name=""
                          v-model="formObjAccount.email"
                          required
                        />
                        <v-errors :errors="errorFor('email')"></v-errors>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form_group">
                        <label>Phone</label>
                        <input
                          type="text"
                          name=""
                          v-model="formObjAccount.phone"
                          required
                        />
                        <v-errors :errors="errorFor('phone')"></v-errors>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <!-- <div class="form_group">
                        <label>Address</label>
                        <input
                          type="text"
                          name=""
                          v-model="formObjAccount.address"
                        />
                        <v-errors :errors="errorFor('address')"></v-errors>
                      </div> -->
                      <div class="form_group">
                        <label>Address</label>
                        <vue-google-autocomplete
                          ref="address"
                          id="map"
                          placeholder="Street address, city, state"
                          v-on:placechanged="getAddressData"
                          country="us"
                          :value="formObjAccount.address"
                        >
                        </vue-google-autocomplete>
                        <v-errors :errors="errorFor('address')"></v-errors>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form_group">
                        <label>Apartments</label>
                        <input
                          type="text"
                          name=""
                          placeholder="Apt # (opt)"
                          v-model="formObjAccount.apt_num"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form_group">
                        <label>Zip Code</label>
                        <input
                          type="text"
                          name=""
                          placeholder="Zip Code"
                          v-model="formObjAccount.zip_code"
                          @input="checkPostal()"
                        />
                        <v-errors :errors="errorFor('address')"></v-errors>
                        <transition name="fade" v-if="is_postal_found == false">
                          <div class="error_message">
                            <strong>Sorry!</strong> we do not currently service
                            this area!
                          </div>
                        </transition>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="order_buttons">
                      <input
                        type="submit"
                        class="button primary_button"
                        value="Update"
                      />
                    </div>
                  </div>
                  <hr />
                </form>
                <form @submit.prevent="updatePassword()">
                  <div class="update_password">
                    <h3>Update Password</h3>
                    <div class="row">
                      <div
                        class="alert alert-success alert-dismissible"
                        v-if="
                          status &&
                          status.password_success &&
                          status.password_success == 200
                        "
                      >
                        <strong>Success!</strong> Action performed successfully.
                      </div>
                      <div class="col-md-6">
                        <div class="form_group">
                          <label>Old Password</label>
                          <input
                            type="password"
                            name=""
                            v-model="formObjPassword.current_password"
                            required
                            placeholder="********"
                          />
                          <v-errors
                            :errors="errorFor('current_password')"
                          ></v-errors>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form_group">
                          <label>New Password</label>
                          <input
                            type="password"
                            name=""
                            v-model="formObjPassword.new_password"
                            required
                            placeholder="********"
                            @input="matchPassword()"
                          />
                          <transition-group name="fade" v-if="errors">
                            <p
                              v-for="(error, keyIndex) in errors"
                              :key="keyIndex + 'from'"
                            >
                              <span
                                v-if="error.password"
                                style="color: #b22222"
                                >{{ error.password }}</span
                              >
                            </p>
                          </transition-group>
                          <v-errors
                            :errors="errorFor('new_password')"
                          ></v-errors>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form_group">
                          <label>Confirm New Password</label>
                          <input
                            type="password"
                            name=""
                            v-model="formObjPassword.confirm_password"
                            required
                            placeholder="********"
                            @input="matchPassword()"
                          />
                          <transition-group name="fade" v-if="errors">
                            <p
                              v-for="(error, keyIndex) in errors"
                              :key="keyIndex + 'from'"
                            >
                              <span
                                v-if="error.password"
                                style="color: #b22222"
                                >{{ error.password }}</span
                              >
                            </p>
                          </transition-group>
                          <v-errors
                            :errors="errorFor('confirm_password')"
                          ></v-errors>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="order_buttons">
                          <input
                            type="submit"
                            class="button primary_button"
                            value="Update"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
  <!--   Main Content End Here   -->
</template>

<script>
import sidebarComponent from "./sidebar";
import { getCurrentUser } from "../../utils/auth";
import { is422 } from "../../utils/response";
import validationErrors from "../../mixins/validationErrors";
import usersApis from "../../Apis/users";
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  mixins: [validationErrors],
  components: {
    sidebarComponent,
    VueGoogleAutocomplete,
  },
  data() {
    return {
      is_postal_found: null,
      accountAddress: !!localStorage.getItem("current_user")
        ? JSON.parse(localStorage.getItem("current_user")).address
        : "",
      given_areas: [],
      loader: true,

      errors: null,
      status: null,

      formObjAccount: {
        id: null,
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        address: null,
        zip_code: null,
        apt_num: null,
      },
      formObjPassword: {
        id: null,
        current_password: null,
        new_password: null,
        confirm_password: null,
      },
    };
  },
  methods: {
    dumpGivenAreas() {
      this.given_areas.push("02127");
      this.given_areas.push("02118");
      this.given_areas.push("02123");
      this.given_areas.push("02116");
      this.given_areas.push("02108");
      this.given_areas.push("02215");
      this.given_areas.push("02120");
      this.given_areas.push("02474");
      this.given_areas.push("02476");
      this.given_areas.push("02134");
      this.given_areas.push("02478");
      this.given_areas.push("02135");
      this.given_areas.push("02445");
      this.given_areas.push("02446");
      this.given_areas.push("02138");
      this.given_areas.push("02138");
      this.given_areas.push("02139");
      this.given_areas.push("02140");
      this.given_areas.push("02141");
      this.given_areas.push("02142");
      this.given_areas.push("02163");
      this.given_areas.push("02238");
      this.given_areas.push("02150");
      this.given_areas.push("02108");
      this.given_areas.push("02109");
      this.given_areas.push("02110");
      this.given_areas.push("02111");
      this.given_areas.push("02112");
      this.given_areas.push("02117");
      this.given_areas.push("02118");
      this.given_areas.push("02127");
      this.given_areas.push("02113");
      this.given_areas.push("02114");
      this.given_areas.push("02115");
      this.given_areas.push("02116");
      this.given_areas.push("02123");
      this.given_areas.push("02128");
      this.given_areas.push("02133");
      this.given_areas.push("02163");
      this.given_areas.push("02196");
      this.given_areas.push("02199");
      this.given_areas.push("02205");
      this.given_areas.push("02206");
      this.given_areas.push("02212");
      this.given_areas.push("02215");
      this.given_areas.push("02266");
      this.given_areas.push("02283");
      this.given_areas.push("02201");
      this.given_areas.push("02203");
      this.given_areas.push("02204");
      this.given_areas.push("02210");
      this.given_areas.push("02211");
      this.given_areas.push("02217");
      this.given_areas.push("02222");
      this.given_areas.push("02241");
      this.given_areas.push("02284");
      this.given_areas.push("02293");
      this.given_areas.push("02295");
      this.given_areas.push("02297");
      this.given_areas.push("02298");
      this.given_areas.push("02129");
      this.given_areas.push("02467");
      this.given_areas.push("02121");
      this.given_areas.push("02122");
      this.given_areas.push("02124");
      this.given_areas.push("02125");
      this.given_areas.push("02149");
      this.given_areas.push("02130");
      this.given_areas.push("02148");
      this.given_areas.push("02153");
      this.given_areas.push("02155");
      this.given_areas.push("02176");
      this.given_areas.push("02492");
      this.given_areas.push("02461");
      this.given_areas.push("02464");
      this.given_areas.push("02459");
      this.given_areas.push("02465");
      this.given_areas.push("02458");
      this.given_areas.push("02462");
      this.given_areas.push("02151");
      this.given_areas.push("02118");
      this.given_areas.push("02119");
      this.given_areas.push("02120");
      this.given_areas.push("02170");
      this.given_areas.push("02169");
      this.given_areas.push("02171");
      this.given_areas.push("02269");
      this.given_areas.push("02144");
      this.given_areas.push("02145");
      this.given_areas.push("02451");
      this.given_areas.push("02452");
      this.given_areas.push("02453");
      this.given_areas.push("02454");
      this.given_areas.push("02472");
      this.given_areas.push("02471");
      this.given_areas.push("02477");
      this.given_areas.push("02482");
      this.given_areas.push("02132");
      this.given_areas.push("01890");
      this.loader = false;
    },
    checkPostal() {
      console.log("check postal called");
      const index = this.given_areas.findIndex(
        (it) => it == this.formObjAccount.zip_code
      );
      if (index === -1) {
        this.is_postal_found = false;
      } else {
        this.is_postal_found = true;
      }
    },

    getAddressData: function (addressData, placeResultData, id) {
      this.formObjAccount.address =
        placeResultData && placeResultData.formatted_address
          ? placeResultData.formatted_address
          : "";

      if (addressData && addressData.postal_code) {
        this.formObjAccount.zip_code = addressData.postal_code;
        this.is_show_postal = false;
        const index = this.given_areas.findIndex(
          (it) => it == addressData.postal_code
        );
        if (index === -1) {
          /**postal code not exist in array */
          this.is_postal_found = false;
        } else {
          /**postal code exist in array */
          this.is_postal_found = true;
        }
      } else {
        this.is_show_postal = true;
      }
    },

    // matching passwords
    matchPassword() {
      if (
        this.formObjPassword.new_password &&
        this.formObjPassword.confirm_password &&
        this.formObjPassword.new_password !=
          this.formObjPassword.confirm_password
      ) {
        this.errors = [{ password: "Password does not match" }];
        return;
      } else {
        return (this.errors = null);
      }
    },
    async updateAccount() {
      const data = await usersApis
        .requestUsers("put", this.formObjAccount)
        .then((response) => {
          console.log(response);
          if (response.status == 200 || response.status == 204) {
            this.status = { account_success: 200 };
            localStorage.setItem("current_user", JSON.stringify(response.data));

            setTimeout(() => {
              this.status = null;
            }, 3000);
          }
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
          if (is422(error)) {
            this.errors = error.response.data.errors;
          }
          this.status =
            error.response && error.response.status
              ? error.response.status
              : "";
          console.log(this.errors, this.status);
        })
        .then(() => {
          this.loader = false;
        });
    },
    updatePassword() {
      usersApis
        .updatePassword(this.formObjPassword.id, this.formObjPassword)
        .then((response) => {
          console.log(response);
          if (response.status == 200 || response.status == 204) {
            this.status = { password_success: 200 };

            setTimeout(() => {
              this.status = null;
            }, 3000);
          }
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
          if (is422(error)) {
            this.errors = error.response.data.errors;
          }
          this.status =
            error.response && error.response.status
              ? error.response.status
              : "";
          console.log(this.errors, this.status);
        })
        .then(() => {
          this.loader = false;
        });
    },
  },
  created() {
    this.dumpGivenAreas();
    const user = getCurrentUser();
    this.formObjAccount = user;
    this.formObjPassword.id = user.id;
    setTimeout(() => {
      this.loader = false;
    }, 1000);
  },
};
</script>


// WEBPACK FOOTER //
// src/components/accounts/my-profile.vue